import { Header } from "../../components/shared/Header";
import { Footer } from "../../components/shared/Footer";
import { AboutModules } from "../../components/about/AboutModules";
import { AboutNotice, AboutTransparency } from "../../components/about/AboutSections";
import { usePageMeta } from "../../hooks/usePageMeta";
import { useJsonLd } from "../../hooks/useJsonLd";
import { aboutJsonLd } from "../../lib/homeJsonLd";
import { SITE_URL } from "../../lib/seo";
import content from "../../data/content.json";

const { about } = content;

export default function SobrePage() {
  usePageMeta(about.metaTitle, about.metaDescription, `${SITE_URL}/sobre`);
  useJsonLd([aboutJsonLd]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main data-testid="about-page" className="flex-1">
        <article className="mx-auto max-w-5xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
          <header>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500">{about.eyebrow}</p>
            <h1 data-testid="about-title" className="mt-6 text-4xl font-semibold leading-[1.08] tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">{about.title}</h1>
            <p data-testid="about-subtitle" className="mt-6 max-w-3xl text-base leading-relaxed text-slate-300 md:text-lg">{about.subtitle}</p>
          </header>
          <section data-testid="about-intro" aria-label="Natureza do serviço" className="mt-12 max-w-3xl space-y-4 text-sm leading-relaxed text-slate-300 sm:text-base">
            {about.intro.map((p) => <p key={p}>{p}</p>)}
          </section>
          <AboutNotice />
          <section aria-labelledby="about-steps-title" className="mt-16">
            <h2 id="about-steps-title" className="text-base font-semibold text-slate-100 md:text-lg">Como funciona</h2>
            <ol data-testid="about-steps" className="mt-6 grid gap-6 md:grid-cols-3">
              {about.steps.map((s, i) => (
                <li key={s.title} className="rounded-md border border-slate-800 bg-slate-900 p-6">
                  <span className="font-mono text-xs text-emerald-500">0{i + 1}</span>
                  <h3 className="mt-3 font-semibold text-slate-100">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.text}</p>
                </li>
              ))}
            </ol>
          </section>
          <AboutModules />
          <AboutTransparency />
        </article>
      </main>
      <Footer />
    </div>
  );
}
